module.exports = __webpack_public_path__ + "img/sign-67.cf07cb30.jpg";